export default "__VITE_ASSET__ik45NPoA__"